import { Box, Typography } from '@mui/material';

/**
 * DataItem — label-over-value display block used across detail tabs.
 * Canonical replacement for the per-page copies.
 *
 * @param {string}    label      — Field label
 * @param {ReactNode} children   — Field value
 * @param {boolean}   [bold]     — Bold value text
 * @param {string}    [color]    — Value text color (palette path)
 * @param {object}    [sx]       — Root overrides
 */
const DataItem = ({ label, children, bold, color, sx }) => (
  <Box sx={{ py: 0.5, ...sx }}>
    <Typography variant="caption" color="text.secondary" component="div" sx={{ lineHeight: 1.4 }}>
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={bold ? 700 : 500} color={color || 'text.primary'}>
      {children ?? '—'}
    </Typography>
  </Box>
);

export default DataItem;
